import { render } from "./LocalWorkExperience.vue?vue&type=template&id=8b324cc0&scoped=true&ts=true"
import script from "./LocalWorkExperience.vue?vue&type=script&lang=ts"
export * from "./LocalWorkExperience.vue?vue&type=script&lang=ts"

import "./LocalWorkExperience.vue?vue&type=style&index=0&id=8b324cc0&scoped=true&lang=css"
import "./LocalWorkExperience.vue?vue&type=style&index=1&id=8b324cc0&lang=css"

import exportComponent from "/home/bwhite/Projects/bryanchriswhite-com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b324cc0"]])

export default __exports__